<template>
    <div class="md:grid md:grid-cols-12 md:gap-6">
        <section-title>
            <template #title><slot name="title"></slot></template>
            <template #description><slot name="description"></slot></template>
        </section-title>

        <div class="mt-5 md:mt-0 md:col-span-6">
            <form @submit.prevent="$emit('submitted')">
                <div class="grid grid-cols-12 gap-6">
                    <slot name="form"></slot>
                </div>

                <div class="pt-4">
                    <slot name="additionals"></slot>
                </div>

                <div class="py-3">
                    <slot name="actions"></slot>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import SectionTitle from "@/components/SectionTitle.vue";
</script>
